import styled from "styled-components";

export const ModalTitle = styled.h2`
  font-size: x-large;
  color: var(--color-brand-600);
  margin: 10px 0 16px 0;
`;

export const ModalContent = styled.div`
  .checkbox-line {
    margin-top: 4px;
    align-items: center;
    gap: 0;
  }

  .days-label {
    margin: 12px 0 4px 0;
  }
`;

export const Line = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: start;
  gap: 16px;

  label {
    line-height: 0;
    display: contents;
  }

  .input-capacity {
    padding-top: 5px;
  }

  .checkbox-clear-dates {
    margin-left: -10px;
  }
`;

export const CheckboxLabel = styled.label`
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: var(--color-contrast-brand);
`;

interface IWeekdayButtonProps {
  selected: boolean;
}

export const WeekdayButton = styled.button<IWeekdayButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  background-color: ${(props) => (props.selected ? "var(--color-brand-300)" : "transparent")};
  color: ${(props) => (props.selected ? "var(--color-contrast-white)" : "var(--color-brand-200)")};
  font-weight: var(--font-weight-semibold);
  border: 1px solid var(--color-brand-100);
  border-radius: 2px;
  border-top-width: 3px;
  cursor: pointer;

  &:hover {
    background-color: none;
    color: none;
  }

  &:disabled:hover {
    cursor: not-allowed;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  margin-top: 32px;
  gap: 12px;

  button{
    margin: 0 !important;
  }
`;